import { Row } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { IMAGES } from '~/assets/assetsPath';
import styles from './Policy.module.scss';
import policyAPI from '~/api/PolicyAPI';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';

const cx = classNames.bind(styles);

const Policy = () => {
    const [content, setContent] = useState({});
    const handleGetContentPolicy = async () => {
        try {
            const res = await policyAPI.getContentPolicyAPI();
            setContent(res?.results.object);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        handleGetContentPolicy();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangChinhSachBaoMat');
        // eslint-disable-next-line
    }, []);

    return (
        <div className="">
            <div className={cx('banner')}>
                <img src={IMAGES.ImageBannerServiceProduct} alt="Banner Spa" />
                {/* <span>{content?.title}</span> */}
            </div>
            <div className={cx('service_home_spa')}>
                <Row>
                    <div dangerouslySetInnerHTML={{ __html: content?.description }}></div>
                </Row>
            </div>
        </div>
    );
};

export default Policy;
